import { render, staticRenderFns } from "./LabelsOverview.vue?vue&type=template&id=ef56d03e&scoped=true"
import script from "./LabelsOverview.vue?vue&type=script&lang=js"
export * from "./LabelsOverview.vue?vue&type=script&lang=js"
import style0 from "./LabelsOverview.vue?vue&type=style&index=0&id=ef56d03e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef56d03e",
  null
  
)

export default component.exports